// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__12hcI","visibleHandle":"Handle_visibleHandle__2sVZC","dragged":"Handle_dragged__2TEHv"};